import React from 'react';

import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';

import './table-head.scss';

// COLUMNS is an ARRAY of STRINGS, where each COLUMN is the KEY in LABELS.TS {KEY: VALUE} pair
export interface ITableHead extends IComponent {
  columns: string[];
  colspans?: number[];
  isVisible?: boolean;
}

const classNames = (className: string, isVisible: boolean) => {
  return makeClassNames({
    table: [className, !isVisible && `${className}--hidden`],
    row: `${className}__row`,
    cell: `${className}__cell`,
  });
};

/**
 * Results Table HEAD for SEO metadata
 * (it's always hidden by default)
 * @param {String[]} columns - Columns labels
 * @param {Number[]} colspans - Column colspan value
 */
const TableHead = ({
  columns,
  /* istanbul ignore next: default value */ colspans = [],
  /* istanbul ignore next: default value */ className = 'table-head',
  /* istanbul ignore next: default value */ isVisible = false,
}: ITableHead) => {
  const cn = classNames(className, isVisible);

  return (
    <thead className={cn.table}>
      <tr className={cn.row}>
        {columns.map((column: string, key: number) => (
          <th
            className={`${cn.cell} ${cn.cell}--w${String(key + 1).padStart(2, '0')}`}
            key={column}
            colSpan={colspans && colspans[key] ? colspans[key] : 1}
          >
            {column}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHead;
